import type { ActaCorteObra } from './tipos'

const formatearCOP = (val: number) =>
  new Intl.NumberFormat('es-CO', {
    style: 'currency',
    currency: 'COP',
    maximumFractionDigits: 0,
  }).format(val || 0)

export function imprimirActaCortePdf(acta: ActaCorteObra) {
  let capitulosHtml = ''

  acta.detalles_capitulos.forEach((cap, capIdx) => {
    let filasItems = ''

    cap.items.forEach((it, itIdx) => {
      filasItems += `
        <tr>
          <td style="text-align: center; color: #64748b; font-size: 10px;">${capIdx + 1}.${itIdx + 1}</td>
          <td style="font-family: monospace; font-size: 10px; font-weight: 600; color: #4338ca;">${it.codigo}</td>
          <td style="font-size: 10px; color: #1e293b; line-height: 1.3;">${it.nombre}</td>
          <td style="text-align: center; font-size: 10px; font-weight: 600;">${it.unidad}</td>
          <td style="text-align: right; font-size: 10px;">${it.cantidad_contratada.toLocaleString('es-CO')}</td>
          <td style="text-align: right; font-size: 10px; color: #64748b;">${it.cantidad_anterior.toLocaleString('es-CO')}</td>
          <td style="text-align: right; font-size: 10px; font-weight: 700; color: #059669;">${it.cantidad_este_corte.toLocaleString('es-CO')}</td>
          <td style="text-align: right; font-size: 10px; font-weight: 600;">${it.cantidad_acumulada.toLocaleString('es-CO')}</td>
          <td style="text-align: right; font-size: 10px;">${it.porcentaje_ejecutado}%</td>
          <td style="text-align: right; font-size: 10px;">${formatearCOP(it.precio_unitario)}</td>
          <td style="text-align: right; font-size: 10px; font-weight: 700; color: #0f172a;">${formatearCOP(it.subtotal_corte)}</td>
        </tr>
      `
    })

    capitulosHtml += `
      <div style="margin-bottom: 20px; page-break-inside: avoid;">
        <div style="background-color: #312e81; color: #ffffff; padding: 5px 10px; font-weight: 700; font-size: 11px; border-radius: 4px 4px 0 0; display: flex; justify-content: space-between;">
          <span>${cap.nombre.toUpperCase()}</span>
          <span>VALOR CORTE CAPÍTULO: ${formatearCOP(cap.subtotal_capitulo)}</span>
        </div>
        <table style="width: 100%; border-collapse: collapse; font-family: sans-serif; font-size: 10px; border: 1px solid #cbd5e1; border-top: none;">
          <thead>
            <tr style="background-color: #f8fafc; border-bottom: 2px solid #cbd5e1; color: #475569; font-size: 9px; text-transform: uppercase;">
              <th style="padding: 5px 6px; width: 35px; text-align: center;">Ítem</th>
              <th style="padding: 5px 6px; width: 80px; text-align: left;">Cód. APU</th>
              <th style="padding: 5px 6px; text-align: left;">Actividad</th>
              <th style="padding: 5px 6px; width: 35px; text-align: center;">Und</th>
              <th style="padding: 5px 6px; width: 55px; text-align: right;">Contrat.</th>
              <th style="padding: 5px 6px; width: 50px; text-align: right;">Anterior</th>
              <th style="padding: 5px 6px; width: 55px; text-align: right; background-color: #ecfdf5; color: #065f46;">Este Corte</th>
              <th style="padding: 5px 6px; width: 55px; text-align: right;">Acumul.</th>
              <th style="padding: 5px 6px; width: 45px; text-align: right;">% Ejec.</th>
              <th style="padding: 5px 6px; width: 80px; text-align: right;">V. Unitario</th>
              <th style="padding: 5px 6px; width: 90px; text-align: right;">V. Este Corte</th>
            </tr>
          </thead>
          <tbody>
            ${filasItems}
          </tbody>
        </table>
      </div>
    `
  })

  const html = `
    <!DOCTYPE html>
    <html lang="es">
    <head>
      <meta charset="utf-8">
      <title>Acta de Corte ${acta.consecutivo} - MEGA DISTRIBUCIONES</title>
      <style>
        @page { size: letter landscape; margin: 12mm; }
        body { font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif; color: #1e293b; margin: 0; padding: 15px; font-size: 11px; }
        table th, table td { padding: 4px 6px; border-bottom: 1px solid #f1f5f9; }
        .no-print { display: flex; gap: 10px; margin-bottom: 15px; }
        @media print {
          .no-print { display: none !important; }
          body { padding: 0; }
        }
      </style>
    </head>
    <body>
      <div class="no-print">
        <button onclick="window.print()" style="background: #4338ca; color: white; border: none; padding: 8px 16px; border-radius: 6px; cursor: pointer; font-weight: 600;">
          Imprimir / Guardar en PDF
        </button>
        <button onclick="window.close()" style="background: #e2e8f0; color: #334155; border: none; padding: 8px 16px; border-radius: 6px; cursor: pointer;">
          Cerrar
        </button>
      </div>

      <!-- Encabezado Membretado -->
      <div style="display: flex; justify-content: space-between; align-items: flex-start; border-bottom: 2px solid #4338ca; padding-bottom: 10px; margin-bottom: 12px;">
        <div>
          <h1 style="margin: 0; font-size: 18px; color: #4338ca; font-weight: 900; letter-spacing: -0.5px;">MEGA DISTRIBUCIONES S.A.S.</h1>
          <p style="margin: 2px 0 0; font-size: 10px; color: #64748b;">NIT: 900.542.891-4 • Acta de Medición y Corte de Obra Contractual</p>
          <p style="margin: 2px 0 0; font-size: 10px; color: #64748b;">Girón - Santander • soporte@megadistribuciones.com</p>
        </div>
        <div style="text-align: right;">
          <div style="font-size: 16px; font-weight: 900; color: #0f172a;">${acta.consecutivo}</div>
          <div style="font-size: 11px; font-weight: 700; color: #4338ca;">CORTE DE OBRA No. ${acta.numero_corte}</div>
          <div style="font-size: 10px; color: #64748b; margin-top: 2px;">Fecha de Corte: ${acta.fecha_corte}</div>
          <div style="display: inline-block; padding: 2px 6px; border-radius: 10px; font-size: 9px; font-weight: 700; background: #dcfce7; color: #15803d; margin-top: 3px;">
            ESTADO: ${acta.estado.toUpperCase()}
          </div>
        </div>
      </div>

      <!-- Ficha Técnica del Corte -->
      <div style="background-color: #f8fafc; border: 1px solid #e2e8f0; border-radius: 6px; padding: 8px 12px; margin-bottom: 16px; display: grid; grid-template-columns: 2fr 1.5fr 1.5fr; gap: 8px; font-size: 10px;">
        <div>
          <div><strong>Cliente / Contratante:</strong> ${acta.cliente_nombre}</div>
          <div><strong>Ing. Residente MEGA:</strong> ${acta.residente_nombre}</div>
        </div>
        <div>
          <div><strong>Interventoría / Supervisión:</strong> ${acta.interventor_nombre || 'Pendiente'}</div>
          <div><strong>Período Medido:</strong> ${acta.fecha_inicio_periodo || 'Inicio'} al ${acta.fecha_fin_periodo || acta.fecha_corte}</div>
        </div>
        <div>
          <div><strong>Plazo Pago Pactado:</strong> ${acta.dias_credito} días fecha radicación</div>
          <div><strong>Fecha Cobro / Recaudo:</strong> ${acta.fecha_cobro || 'Pendiente de cobro'}</div>
        </div>
      </div>

      <!-- Tablas de Capítulos e Ítems -->
      ${capitulosHtml}

      <!-- Resumen de Cobro y AIU -->
      <div style="display: flex; justify-content: flex-end; margin-top: 10px; page-break-inside: avoid;">
        <table style="width: 320px; border-collapse: collapse; font-size: 10px;">
          <tr>
            <td style="color: #64748b; text-align: right; padding: 3px 6px;">Costo Directo Ejecutado en Corte:</td>
            <td style="text-align: right; font-weight: 600; padding: 3px 6px;">${formatearCOP(acta.valor_costo_directo)}</td>
          </tr>
          <tr>
            <td style="color: #64748b; text-align: right; padding: 3px 6px;">AIU Contractual Acordado:</td>
            <td style="text-align: right; font-weight: 600; padding: 3px 6px;">${formatearCOP(acta.valor_aiu)}</td>
          </tr>
          <tr style="border-top: 2px solid #0f172a; background-color: #f1f5f9;">
            <td style="font-weight: 800; font-size: 11px; color: #0f172a; text-align: right; padding: 6px;">VALOR TOTAL A COBRAR EN ACTA:</td>
            <td style="font-weight: 800; font-size: 12px; color: #059669; text-align: right; padding: 6px;">${formatearCOP(acta.valor_total)}</td>
          </tr>
        </table>
      </div>

      <!-- Firmas Contractuales de Sustento de Pago -->
      <div style="display: grid; grid-template-columns: 1fr 1fr 1fr; gap: 30px; margin-top: 40px; page-break-inside: avoid;">
        <div style="border-top: 1px solid #94a3b8; padding-top: 6px; text-align: center;">
          <p style="margin: 0; font-weight: 700; font-size: 10px;">ING. RESIDENTE DE OBRA</p>
          <p style="margin: 2px 0 0; font-size: 9px; color: #64748b;">${acta.residente_nombre}</p>
          <p style="margin: 1px 0 0; font-size: 9px; color: #94a3b8;">MEGA DISTRIBUCIONES S.A.S.</p>
        </div>
        <div style="border-top: 1px solid #94a3b8; padding-top: 6px; text-align: center;">
          <p style="margin: 0; font-weight: 700; font-size: 10px;">INTERVENTORÍA / SUPERVISIÓN</p>
          <p style="margin: 2px 0 0; font-size: 9px; color: #64748b;">${acta.interventor_nombre || 'Firma y T.P.'}</p>
          <p style="margin: 1px 0 0; font-size: 9px; color: #94a3b8;">Auditoría Técnica de Contrato</p>
        </div>
        <div style="border-top: 1px solid #94a3b8; padding-top: 6px; text-align: center;">
          <p style="margin: 0; font-weight: 700; font-size: 10px;">APROBADO POR CLIENTE / CONTRATANTE</p>
          <p style="margin: 2px 0 0; font-size: 9px; color: #64748b;">${acta.cliente_nombre}</p>
          <p style="margin: 1px 0 0; font-size: 9px; color: #94a3b8;">Sustento de Pago y Radicación</p>
        </div>
      </div>
    </body>
    </html>
  `

  const win = window.open('', '_blank', 'width=1100,height=800')
  if (win) {
    win.document.open()
    win.document.write(html)
    win.document.close()
  }
}

